import { validShareToken } from "./shareToken.js";

export function sharedProfileLink(token, mode, location = window.location) {
  const origin = location.hostname === "localhost" ? "https://regulator.dannyb.co" : location.origin;
  return `${origin}/#/shared/${token}?mode=${mode}`;
}

export async function parseSharedProfileLink(value) {
  const input = String(value ?? "").trim();
  if (await validShareToken(input)) return { token: input, mode: "share" };
  try {
    const hash = new URL(input, window.location.origin).hash;
    const match = hash.match(/^#\/shared\/([^/?#]+)(?:\?(.+))?$/);
    const token = match ? decodeURIComponent(match[1]) : "";
    const mode = new URLSearchParams(match?.[2] ?? "").get("mode") ?? "share";
    if (!["share", "sync"].includes(mode)) throw new Error("invalid mode");
    if (await validShareToken(token)) return { token, mode };
  } catch { /* Report the common validation error below. */ }
  throw new Error("Enter a valid Regulator sharing link.");
}

export function sharedRouteParts(value) {
  const [encodedToken = "", query = ""] = String(value ?? "").split("?");
  const mode = new URLSearchParams(query).get("mode") === "sync" ? "sync" : "share";
  try { return { token: decodeURIComponent(encodedToken), mode }; } catch { return { token: encodedToken, mode }; }
}
